<div class="gs-list">

    <!-- ── Header bar ──────────────────────────────────────────────────── -->
    <div class="gs-list__header-bar">
      <div class="gs-list__header-left">
        @if (iconSrc()) {
          <div class="gs-list__icon-wrapper">
            <img [src]="iconSrc()" alt="" class="gs-list__icon" />
          </div>
        }
        <span class="gs-list__title">{{ title() }}</span>
      </div>
      <button class="gs-list__back-btn" type="button" (click)="backClicked.emit()">
        <p>{{ backButtonLabel() }}</p>
      </button>
    </div>

    <!-- ── Toolbar ─────────────────────────────────────────────────────── -->
    <div class="gs-list__toolbar">
      <div class="gs-list__search-wrapper">
        <input
          class="gs-list__search-input"
          type="text"
          [placeholder]="searchPlaceholder()"
          [value]="searchTerm()"
          (input)="onSearchInput($event)"
        />
        @if (searchTerm()) {
          <button class="gs-list__search-clear-btn" type="button" (click)="onClearSearch()" aria-label="Clear search">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <path d="M12 4L4 12M4 4L12 12" stroke="rgba(33,33,37,0.5)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        } @else {
          <svg class="gs-list__search-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
            <path d="M14 14l-3.5-3.5M10.5 6.5a4 4 0 1 1-8 0 4 4 0 0 1 8 0z" stroke="rgba(33,33,37,0.36)" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        }
      </div>
      <button class="gs-list__add-btn" type="button" (click)="addNewClicked.emit()">
        {{ addButtonLabel() }}
      </button>
    </div>

    <!-- ── Projected table content ─────────────────────────────────────── -->
    <div class="gs-list__table-wrapper">
      @if (isLoading()) {
        <div class="gs-list__loader">
          <app-loader></app-loader>
        </div>
      } @else if (totalCount() > 0) {
        <ng-content></ng-content>
      } @else if (searchTerm()) {
        <div class="gs-list__empty-state">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <circle cx="11" cy="11" r="7.5" stroke="rgba(33,33,37,0.25)" stroke-width="1.5"/>
            <path d="M17 17l3.5 3.5" stroke="rgba(33,33,37,0.25)" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
          <p class="gs-list__empty-state-text">{{ noResultsLabel() }}</p>
        </div>
      } @else {
        <div class="gs-list__empty-state">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <rect x="3" y="5" width="18" height="14" rx="2" stroke="rgba(33,33,37,0.25)" stroke-width="1.5"/>
            <path d="M3 9h18" stroke="rgba(33,33,37,0.25)" stroke-width="1.5"/>
          </svg>
          <p class="gs-list__empty-state-text">{{ emptyStateLabel() }}</p>
        </div>
      }
    </div>

    <!-- ── Footer ─────────────────────────────────────────────────────── -->
    @if (showFooter()) {
      <div class="gs-list__footer">
        <span class="gs-list__total-label">{{ totalLabel() }}</span>
        <span class="gs-list__total-count">{{ totalCount() }}</span>
      </div>
    }

  </div>
